import { setQueryParam } from 'www/utils'

function setQueryDoctorEquipment(doctorId, equipmentId) {
  setQueryParam('doctorId', doctorId || '')
  setQueryParam('equipmentId', equipmentId || '')
}

export default setQueryDoctorEquipment
